module.exports = __webpack_public_path__ + "static/media/TK.6465e4b1.svg";